export enum authStateActions {
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  LOGOUT = "LOGOUT",
  LOGIN_FAILED = "LOGIN_FAILED",
  SIGNUP = "SIGNUP",
  SIGNUP_FAILED = "SIGNUP_FAILED",
  SIGNUP_SUCCESS = "SIGNUP_SUCCESS",
  LOADING = "LOADING",
  CLEAR_ERROR = "CLEAR_ERROR",
}
